import React, { Component, push } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Console,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Close,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import UpcomingEvtDisplay from "./UpcomingEvtDisplay";
import AppHeader from "./AppHeader";
import Canceldemo from "./Canceldemo";
import { callApiGetJson, callApiPostJson } from "./GlobalSettings";
import auth from "./Security/Auth";

class UserdashboardUpcomingDemos extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bdispCancel: false,
      UsrUpcomingDemos: this.props.Demos,
      // _VRNetLaunchData: this.props.LaunchData,
    };

    this._HPEOnBackClick = this._HPEOnBackClick.bind(this);
    this._Hide = this._Hide.bind(this);
    this._ShowCancel = this._ShowCancel.bind(this);
    this.loadUpcomingEventsData = this.loadUpcomingEventsData.bind(this);
    //this._loadVRNetLaunchInfo = this._loadVRNetLaunchInfo.bind(this);
    //this._HandleCancelClick = this._HandleCancelClick.bind(this);
  }

  componentDidMount() {
    console.log(
      "*** From UpcomingDemoEvts from UsrDashboard View ** Props ",
      this.props.Demos
    );
    this.setState({
      UsrUpcomingDemos: this.props.Demos,
      // _VRNetLaunchData: this.props.LaunchData,
    });
    this._evtInterval = setInterval(() => {
      console.log("Interval started! for upcoming Demo Refresh");
      this.loadUpcomingEventsData();
    }, 30000);
  }

  componentWillUnmount() {
    // clearInterval(this._evtInterval);
  }

  /*   _loadVRNetLaunchInfo() {
    var endpoint = "/Events/GetVRNetLaunchInfo";
    let token = auth.getToken();
    callApiGetJson(endpoint, token).then((data) => {
      //console.log('VRNetLaunchinf data from API:', data);
      this.setState({
        _VRNetLaunchData: data,
      });
    });
  } */

  _HPEOnBackClick() {
    this.props.history.push("/");
  }

  loadUpcomingEventsData() {
    var endpoint = "/Events/GetUpcomingEventsByUser";
    let token = auth.getToken();
    this.setState({ showUpcomingEvtLoader: true });

    callApiGetJson(endpoint, token).then((data) => {
      //console.log('Upcoming Events result data from API:');
      //console.log(data);
      this.setState({
        UsrUpcomingDemos: data,
        // _VRNetLaunchData: this.props.LaunchData,
      });
    });
    //}
  }

  HandlePostCancelResp(evtID) {
    /*     console.log("**Handle Cancel called Back Fired for Event ID ", evtID);
    console.log("State UpcomingData is ", this.state.UsrUpcomingDemos); */
    /*     var _updatedEvts = this.state.UsrUpcomingDemos;
    if (evtID) {
      _updatedEvts.map((_evt) => {
        if (_evt.Event_ID === evtID) {
          _evt.Event_Status.EventStatus_ID = 4;
          _evt.Event_Status.EventStatus_Name = "Cancelled";
        }
      });
      this.setState({ UsrUpcomingDemos: _updatedEvts });
    } */
    //this._Hide();
    //console.log("Updated State should be ", this.state.UsrUpcomingDemos);
  }

  _Hide() {
    this.setState({ bdispCancel: false });
    this.props.hide();
  }

  _ShowCancel() {
    this.setState({ bdispCancel: true });
  }

  render() {
    var bdisplayCancelPop = this.state.bdispCancel;
    var DemoLaunchInfo = undefined;
    var dispUpcomingEvtsList = new Array();
    var cardArray = undefined;

    /*     if (this.state._VRNetLaunchData) {
      DemoLaunchInfo = this.state._VRNetLaunchData;
    } */
    // var UpcomingDemos = this.props.Demos;

    /*     if (this.props.Demos) {
      dispUpcomingEvtsList =
        dispUpcomingEvtsList +
        this.props.Demos.map((demo) => {
          return <UpcomingEvtDisplay Evt={demo} />;
        });
    } */

    this.state.UsrUpcomingDemos.map((dem) => {
      dispUpcomingEvtsList.push(dem);
    });

    console.log("Upcoming UserDemos", this.state.UsrUpcomingDemos);
    console.log("Upcoming UserDemos List", dispUpcomingEvtsList);

    return (
      <Layer full="true" position="center">
        <Box fill="vertical" align="stretch" justify="start">
          <Main
            overflow="auto"
            background={{ image: "url('')" }}
            flex
            align="stretch"
            justify="start"
          >
            <AppHeader />
            <Box
              align="stretch"
              justify="center"
              flex="grow"
              background={{ color: "background-back" }}
              direction="row"
            >
              <Box
                align="stretch"
                justify="start"
                flex="shrink"
                pad={{ horizontal: "large", vertical: "medium" }}
                gap="medium"
                basis="xlarge"
              >
                <Box align="center" justify="end" direction="row">
                  <Button
                    icon={<Close />}
                    onClick={this.props.hide}
                    secondary
                  />
                </Box>
                <Header
                  align="start"
                  direction="column"
                  flex={false}
                  justify="start"
                  gap="xxsmall"
                >
                  {/* <Button
                  label="Home"
                  icon={<FormPrevious />}
                  gap="xsmall"
                  onClick={() => push("/home")}
                /> */}
                  <Box
                    align="center"
                    justify="between"
                    direction="row"
                    alignSelf="stretch"
                  >
                    <Box
                      align="center"
                      justify="center"
                      direction="row"
                      gap="xsmall"
                    >
                      <Heading margin="none">My demo event(s)</Heading>
                    </Box>
                  </Box>
                </Header>
                <Box align="stretch" justify="start">
                  <List data={dispUpcomingEvtsList} pad="xsmall">
                    {(datum, index) => (
                      <UpcomingEvtDisplay
                        Evt={datum}
                        hideCancel={this._Hide}
                        LaunchData={DemoLaunchInfo}
                      />
                      /*                       <Card
                        direction="column"
                        pad="medium"
                        background={{ color: "background" }}
                      >
                        <Box align="stretch" justify="start">
                          <Box
                            align="stretch"
                            justify="start"
                            direction="column"
                          >
                            <Grid
                              columns={["small", "medium"]}
                              gap="xxsmall"
                              align="start"
                              justify="start"
                            >
                              <Text>EventID</Text>
                              <Text>{datum.Event_ID}</Text>
                              <Text>Event Subject</Text>
                              <Text>{datum.Event_Title}</Text>
                              <Text>Event Duration</Text>
                              <Text>{datum.Event_Duration.Duration_Name}</Text>
                              <Text>Event Status</Text>
                              <Text>{datum.Event_Status.EventStatus_Name}</Text>
                            </Grid>
                            <Box
                              align="start"
                              justify="between"
                              direction="row"
                              gap="small"
                              responsive={false}
                              pad="medium"
                            >
                              <Button
                                label="extend (+2h)"
                                primary={false}
                                icon={<AddCircle />}
                              />
                              <Button
                                label="edit"
                                primary={false}
                                icon={<Edit />}
                              />
                              <Button
                                label="cancel"
                                primary={false}
                                icon={<Trash />}
                                onClick={this._ShowCancel}
                              />
                              {bdisplayCancelPop && (
                                <Canceldemo
                                  hide={this._Hide}
                                  DemoToCancel={datum}
                                  HandleCallBack={this.HandlePostCancelResp}
                                />
                              )}
                              <Button
                                label="Launch"
                                primary
                                icon={<Console />}
                              />
                              <Button
                                label="Demo guide"
                                icon={<Download />}
                                secondary
                              />
                            </Box>
                          </Box>
                        </Box>
                      </Card> */
                    )}
                  </List>
                </Box>
              </Box>
            </Box>
          </Main>
        </Box>
      </Layer>
    );
  }
}

export default UserdashboardUpcomingDemos;
